export default "__VITE_ASSET__DtfAcXMV__"